function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

export var LiteYTEmbed = /*#__PURE__*/function (_HTMLElement) {
  _inherits(LiteYTEmbed, _HTMLElement);

  var _super = _createSuper(LiteYTEmbed);

  function LiteYTEmbed() {
    var _this;

    _classCallCheck(this, LiteYTEmbed);

    _this = _super.call(this);
    _this.isIframeLoaded = false;

    _this.setupDom();

    return _this;
  }

  _createClass(LiteYTEmbed, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;

      this.addEventListener('pointerover', LiteYTEmbed.warmConnections, {
        once: true
      });
      this.addEventListener('click', function () {
        return _this2.addIframe();
      });
    }
  }, {
    key: "videoId",
    get: function get() {
      return encodeURIComponent(this.getAttribute('videoid') || '');
    },
    set: function set(id) {
      this.setAttribute('videoid', id);
    }
  }, {
    key: "playlistId",
    get: function get() {
      return encodeURIComponent(this.getAttribute('playlistid') || '');
    },
    set: function set(id) {
      this.setAttribute('playlistid', id);
    }
  }, {
    key: "videoTitle",
    get: function get() {
      return this.getAttribute('videotitle') || 'Video';
    },
    set: function set(title) {
      this.setAttribute('videotitle', title);
    }
  }, {
    key: "videoPlay",
    get: function get() {
      return this.getAttribute('videoPlay') || 'Play';
    },
    set: function set(name) {
      this.setAttribute('videoPlay', name);
    }
  }, {
    key: "videoStartAt",
    get: function get() {
      return this.getAttribute('videoStartAt') || '0';
    }
  }, {
    key: "autoLoad",
    get: function get() {
      return this.hasAttribute('autoload');
    }
  }, {
    key: "noCookie",
    get: function get() {
      return this.hasAttribute('nocookie');
    }
  }, {
    key: "posterQuality",
    get: function get() {
      return this.getAttribute('posterquality') || 'hqdefault';
    }
  }, {
    key: "posterLoading",
    get: function get() {
      return this.getAttribute('posterloading') || 'lazy';
    }
  }, {
    key: "params",
    get: function get() {
      return "start=".concat(this.videoStartAt, "&").concat(this.getAttribute('params'));
    },
    set: function set(opts) {
      this.setAttribute('params', opts);
    }
  }, {
    key: "setupDom",
    value: function setupDom() {
      var shadowDom = this.attachShadow({
        mode: 'open'
      });
      var nonce = '';

      if (window.liteYouTubeNonce) {
        nonce = "nonce=\"".concat(window.liteYouTubeNonce, "\"");
      }

      shadowDom.innerHTML = "\n      <style ".concat(nonce, ">\n        :host {\n          contain: content;\n          display: block;\n          position: relative;\n          width: 100%;\n          padding-bottom: calc(100% / (16 / 9));\n        }\n\n        @media (max-width: 40em) {\n          :host([short]) {\n            padding-bottom: calc(100% / (9 / 16));\n          }\n        }\n\n        #frame, #fallbackPlaceholder, iframe {\n          position: absolute;\n          width: 100%;\n          height: 100%;\n          left: 0;\n        }\n\n        #frame {\n          cursor: pointer;\n        }\n\n        #fallbackPlaceholder {\n          object-fit: cover;\n        }\n\n        #frame::before {\n          content: '';\n          display: block;\n          position: absolute;\n          top: 0;\n          background-image: linear-gradient(180deg, #111 -20%, transparent 90%);\n          height: 60px;\n          width: 100%;\n          z-index: 1;\n        }\n\n        #playButton {\n          width: 68px;\n          height: 48px;\n          background-color: transparent;\n          background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 48\"><path d=\"M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z\" fill=\"red\"/><path d=\"M45 24 27 14v20\" fill=\"white\"/></svg>');\n          z-index: 1;\n          border: 0;\n          border-radius: inherit;\n        }\n\n        #playButton:before {\n          content: '';\n          border-style: solid;\n          border-width: 11px 0 11px 19px;\n          border-color: transparent transparent transparent #fff;\n        }\n\n        #playButton,\n        #playButton:before {\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate3d(-50%, -50%, 0);\n          cursor: inherit;\n        }\n\n        /* Post-click styles */\n        .activated {\n          cursor: unset;\n        }\n\n        #frame.activated::before,\n        #frame.activated > #playButton {\n          display: none;\n        }\n      </style>\n      <div id=\"frame\">\n        <picture>\n          <source id=\"webpPlaceholder\" type=\"image/webp\">\n          <source id=\"jpegPlaceholder\" type=\"image/jpeg\">\n          <img id=\"fallbackPlaceholder\" referrerpolicy=\"origin\" loading=\"lazy\">\n        </picture>\n        <button id=\"playButton\"></button>\n      </div>\n    ");
      this.domRefFrame = shadowDom.querySelector('#frame');
      this.domRefImg = {
        fallback: shadowDom.querySelector('#fallbackPlaceholder'),
        webp: shadowDom.querySelector('#webpPlaceholder'),
        jpeg: shadowDom.querySelector('#jpegPlaceholder')
      };
      this.domRefPlayButton = shadowDom.querySelector('#playButton');
    }
  }, {
    key: "setupComponent",
    value: function setupComponent() {
      this.initImagePlaceholder();
      this.domRefPlayButton.setAttribute('aria-label', "".concat(this.videoPlay, ": ").concat(this.videoTitle));
      this.setAttribute('title', "".concat(this.videoPlay, ": ").concat(this.videoTitle));

      if (this.autoLoad || this.isYouTubeShort()) {
        this.initIntersectionObserver();
      }
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldVal, newVal) {
      switch (name) {
        case 'videoid':
        case 'playlistid':
        case 'videoTitle':
        case 'videoPlay':
          {
            if (oldVal !== newVal) {
              this.setupComponent();

              if (this.domRefFrame.classList.contains('activated')) {
                this.domRefFrame.classList.remove('activated');
                this.shadowRoot.querySelector('iframe').remove();
                this.isIframeLoaded = false;
              }
            }

            break;
          }

        default:
          break;
      }
    }
  }, {
    key: "addIframe",
    value: function addIframe() {
      var isIntersectionObserver = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.isIframeLoaded) {
        var autoplay = isIntersectionObserver ? 0 : 1;
        var wantsNoCookie = this.noCookie ? '-nocookie' : '';
        var embedTarget;

        if (this.playlistId) {
          embedTarget = "?listType=playlist&list=".concat(this.playlistId, "&");
        } else {
          embedTarget = "".concat(this.videoId, "?");
        }

        if (this.isYouTubeShort()) {
          this.params = "loop=1&mute=1&modestbranding=1&playsinline=1&rel=0&enablejsapi=1&playlist=".concat(this.videoId);
          autoplay = 1;
        }

        var iframeHTML = "\n<iframe frameborder=\"0\" title=\"".concat(this.videoTitle, "\"\n  allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen\n  src=\"https://www.youtube").concat(wantsNoCookie, ".com/embed/").concat(embedTarget, "autoplay=").concat(autoplay, "&").concat(this.params, "\"\n></iframe>");
        this.domRefFrame.insertAdjacentHTML('beforeend', iframeHTML);
        this.domRefFrame.classList.add('activated');
        this.isIframeLoaded = true;
        this.attemptShortAutoPlay();
        this.dispatchEvent(new CustomEvent('liteYoutubeIframeLoaded', {
          detail: {
            videoId: this.videoId
          },
          bubbles: true,
          cancelable: true
        }));
      }
    }
  }, {
    key: "initImagePlaceholder",
    value: function initImagePlaceholder() {
      var _this$domRefImg, _this$domRefImg$fallb;

      var posterUrlWebp = "https://i.ytimg.com/vi_webp/".concat(this.videoId, "/").concat(this.posterQuality, ".webp");
      var posterUrlJpeg = "https://i.ytimg.com/vi/".concat(this.videoId, "/").concat(this.posterQuality, ".jpg");
      this.domRefImg.fallback.loading = this.posterLoading;
      this.domRefImg.webp.srcset = posterUrlWebp;
      this.domRefImg.jpeg.srcset = posterUrlJpeg;
      this.domRefImg.fallback.src = posterUrlJpeg;
      this.domRefImg.fallback.setAttribute('aria-label', "".concat(this.videoPlay, ": ").concat(this.videoTitle));
      (_this$domRefImg = this.domRefImg) === null || _this$domRefImg === void 0 ? void 0 : (_this$domRefImg$fallb = _this$domRefImg.fallback) === null || _this$domRefImg$fallb === void 0 ? void 0 : _this$domRefImg$fallb.setAttribute('alt', "".concat(this.videoPlay, ": ").concat(this.videoTitle));
    }
  }, {
    key: "initIntersectionObserver",
    value: function initIntersectionObserver() {
      var _this3 = this;

      var options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
      };
      var observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !_this3.isIframeLoaded) {
            LiteYTEmbed.warmConnections();

            _this3.addIframe(true);

            observer.unobserve(_this3);
          }
        });
      }, options);
      observer.observe(this);
    }
  }, {
    key: "attemptShortAutoPlay",
    value: function attemptShortAutoPlay() {
      var _this4 = this;

      if (this.isYouTubeShort()) {
        setTimeout(function () {
          var _this4$shadowRoot$que, _this4$shadowRoot$que2;

          (_this4$shadowRoot$que = _this4.shadowRoot.querySelector('iframe')) === null || _this4$shadowRoot$que === void 0 ? void 0 : (_this4$shadowRoot$que2 = _this4$shadowRoot$que.contentWindow) === null || _this4$shadowRoot$que2 === void 0 ? void 0 : _this4$shadowRoot$que2.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }, 2000);
      }
    }
  }, {
    key: "isYouTubeShort",
    value: function isYouTubeShort() {
      return this.getAttribute('short') === '' && window.matchMedia('(max-width: 40em)').matches;
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['videoid', 'playlistid'];
    }
  }, {
    key: "addPrefetch",
    value: function addPrefetch(kind, url) {
      var linkElem = document.createElement('link');
      linkElem.rel = kind;
      linkElem.href = url;
      linkElem.crossOrigin = 'true';
      document.head.append(linkElem);
    }
  }, {
    key: "warmConnections",
    value: function warmConnections() {
      if (LiteYTEmbed.isPreconnected || window.liteYouTubeIsPreconnected) return;
      LiteYTEmbed.addPrefetch('preconnect', 'https://i.ytimg.com/');
      LiteYTEmbed.addPrefetch('preconnect', 'https://s.ytimg.com');
      LiteYTEmbed.addPrefetch('preconnect', 'https://www.youtube.com');
      LiteYTEmbed.addPrefetch('preconnect', 'https://www.google.com');
      LiteYTEmbed.addPrefetch('preconnect', 'https://googleads.g.doubleclick.net');
      LiteYTEmbed.addPrefetch('preconnect', 'https://static.doubleclick.net');
      LiteYTEmbed.isPreconnected = true;
      window.liteYouTubeIsPreconnected = true;
    }
  }]);

  return LiteYTEmbed;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
LiteYTEmbed.isPreconnected = false;
customElements.define('lite-youtube', LiteYTEmbed);